import React from "react";
import PropTypes from "prop-types";
import * as DomainConstants from "../../constants/DomainConstants";
import ValidationGroup from "../common/ValidationGroup";
import { orderByPropertyName } from "../../util/orderBy";
import { Popup } from 'semantic-ui-react';

const NieuwbouwInfrastructurenTabel = props => {
    const {
        infrastructurenInDeBuurt,
        disabled,
        errors
    } = props;

    const onEdit = (id) => {
        return function () {
            return props.onEdit(id);
        };
    };

    const onDelete = (id) => {
        return function () {
            return props.onDelete(id);
        };
    };

    function findById(id) {
        const type = props.soortenInfrastructuurAll.find(x => x.id === id);
        if (type) {
            return type.description;
        }
        return "Geen Type";
    }

    const infrastructurenRows = orderByPropertyName(infrastructurenInDeBuurt, "naam").map((infrastructuur, i) => {
        const isTypeAndere = infrastructuur.soortInfrastructuurId == DomainConstants.ANDERE_INFRASTRUCTUUR_GUID ? (
            <span>
                <br />{infrastructuur.andereInfrastructuur}
            </span>)
            : "";

        const icons = !disabled ? (
            <td>
                <span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-pencil fa-fw" onClick={onEdit(infrastructuur.id)}/>} content="Wijzig infrastructuur" /></span>
                <span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-trash fa-fw" onClick={onDelete(infrastructuur.id)}/>} content="Verwijder infrastructuur" /></span>
            </td>) : <td/>;

        return (
            <tr key={i}>
                <td>{infrastructuur.naam}</td>
                <td>{findById(infrastructuur.soortInfrastructuurId)}{isTypeAndere}</td>
                {icons}
            </tr>);
    });

    return (
        <ValidationGroup errors={errors ? errors : undefined}  >
            <table className="c-table hours">
                <thead>
                    <tr>
                        <th width={"50%"}>NAAM VAN DE INFRASTRUCTUUR</th>
                        <th width={"40%"}>TYPE</th>
                        <th width={"10%"}/>
                    </tr>
                </thead>
                <tbody>
                    {infrastructurenRows}
                </tbody>
            </table>
        </ValidationGroup>
    );
};

NieuwbouwInfrastructurenTabel.propTypes = {
    infrastructurenInDeBuurt: PropTypes.arrayOf(PropTypes.object),
    errors: PropTypes.object,
    disabled: PropTypes.bool,
    soortenInfrastructuur: PropTypes.array,
	soortenInfrastructuurAll: PropTypes.array,
    onDelete: PropTypes.func,
    onEdit: PropTypes.func
};

export default NieuwbouwInfrastructurenTabel;
